export default __webpack_public_path__ + "static/media/Despair.2f666dc2.jpg";